
import React from 'react';
import { FlowRender } from "../flow-render";
import {EmploymentRadioButton} from "./employment-radio-button";
import {Text} from "../prm/text";
import { Name } from "../prm/name";
import {StateOptionMenu} from "../prm/state-menu";
import {GreyBox} from "../../client/funcs/utils";
import {OptionMenu} from "../prm/option-menu";

const role_0_employment = new EmploymentRadioButton(
  new Name("role_0_employment"));

const role_0_occupation = new Text(
  new Name("role_0_occupation", "Occupation"), null,
  { path: "name.jobTitle" });

const role_0_yearsEmployed = new Text(
  new Name("role_0_yearsEmployed", "Years Employed"), null,
  { path: "random.num", arg0: 5, arg1: 15 });

const role_0_typeOfBusiness = new Text(
  new Name("role_0_typeOfBusiness", "Type of Business"),
  null, { path: "company.bs" });

const role_0_employerName = new Text(
  new Name("role_0_employerName", "Employer Name"), null,
  { path: "company.companyName"});

const role_0_employerAddress = new Text(
  new Name("role_0_employerAddress", "Employer Address"), null,
  { path: "address.streetAddress"});

const role_0_employerCity = new Text(
  new Name("role_0_employerCity", "Employer City"), null,
  { path: "address.city"});

const role_0_employerState = new StateOptionMenu(
  new Name("role_0_employerState", "Employer State"));
role_0_employerState.fake = 1;

const role_0_employerZip = new Text(
  new Name("role_0_employerZip", "Employer Zip"), null,
  { path: "address.zipCode" });

const role_0_employerCountry = new Text(
  new Name("role_0_employerCountry", "Employer Country"), null,
  { path: "address.country"});

const ROW_3 = (elem_0, elem_1, elem_2) => {
  const style = {
    display: "flex",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
  }
  return (
    <div style={style}>
      <div style={{ flex: "2"}}>
        { elem_0 }
      </div>
      <div style={{ width: "1rem"}}/>
      <div style={{ flex: "1"}}>
        { elem_1 }
      </div>
      <div style={{ width: "1rem"}}/>
      <div style={{ flex: "1"}}>
        { elem_2 }
      </div>
    </div>
  )
}
class Employment extends FlowRender {
  constructor(index) {
    super(index, [
      role_0_employment,
      role_0_occupation,
      role_0_yearsEmployed,
      role_0_typeOfBusiness,
      role_0_employerName,
      role_0_employerAddress,
      role_0_employerCity,
      role_0_employerState,
      role_0_employerZip,
      role_0_employerCountry,
    ]);

    role_0_employment.onChangeCallback = this.onChange;
    role_0_occupation.onChangeCallback = this.onChange;
    role_0_yearsEmployed.onChangeCallback = this.onChange;
    role_0_typeOfBusiness.onChangeCallback = this.onChange;
    role_0_employerName.onChangeCallback = this.onChange;
    role_0_employerAddress.onChangeCallback = this.onChange;
    role_0_employerCity.onChangeCallback = this.onChange;
    role_0_employerState.onChangeCallback = this.onChange;
    role_0_employerZip.onChangeCallback = this.onChange;
    role_0_employerCountry.onChangeCallback = this.onChange;
  }

  dumpEmploymentStatus = component => {
    const container_style = {
      width: "100%",
      display: "flex",
    }
    const prm = role_0_employment;
    const buttons = prm.buttonList;
    const checkbox_style = {
      transform: "scale(1.2) translateY(0.2rem)",
    }
    const label_style = {
      marginLeft: "1.5rem",
    }
    const render_button = (component, index) => {
      return (
        <div style={{ flex: "1"}} key={index}>
          { prm.renderCheckbox(index, component, checkbox_style) }
          { prm.renderLabel(index, component.state, label_style) }
        </div>
      )
    }
    return (
      <div style={container_style}>
        { buttons.map((button, index) => render_button(component, index)) }
      </div>
    )
  }

  canNavigateNext(component) {
    const highlight_rects = [];
    const status = role_0_employment.getValue(component.state, true);
    if (status !== "employed" && status !== "selfEmployed") {
      return component.getRootUrl() + "/investment_knowledge";
    }

    this.prmList.forEach(prm => {
      if (prm.type !== OptionMenu.type) {
        prm.isFilledElseHighlight(component.state, highlight_rects);
      }
    })
    if (highlight_rects.length > 0) {
      component.setState({highlight_rects});
      return null;
    }

    return component.getRootUrl() + "/investment_knowledge";
  }

  render = component => {

    const container_style = {
      width: "75%",
      margin: "auto",
    }

    const render_div = prm => {
      const style = {
        width: "100%",
      }
      if (prm.type === Text.type) {
        return prm.renderInputDiv(component, style, prm.name.label);
      } else if (prm.type === OptionMenu.type) {
        return prm.renderMenuDiv(component, style, prm.name.label);
      }
    }
    const status = role_0_employment.getValue(component.state, true);
    const hide = status !== "employed" && status !== "selfEmployed";
    const most_prm_style = {
      visibility: hide ? "hidden" : "visible",
    }
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Employment", "75%")}
        { this.renderProgress(component, "75%") }
        <section className={"section"}>
          <div style={container_style}>
            <GreyBox>
              { this.dumpEmploymentStatus(component) }
              <div style={{height: "1rem"}}/>
              <div style={most_prm_style}>
                { ROW_3(
                  render_div(role_0_occupation),
                  render_div(role_0_yearsEmployed),
                  render_div(role_0_typeOfBusiness)) }
                { render_div(role_0_employerName) }
                { render_div(role_0_employerAddress) }
                { ROW_3(
                  render_div(role_0_employerCity),
                  render_div(role_0_employerState),
                  render_div(role_0_employerZip)) }
                { render_div(role_0_employerCountry) }
              </div>
            </GreyBox>
          </div>
        </section>
        { this.renderNextButtonRow(component, true) }
      </div>
    )
  }
}

export { Employment };
